<template>
  <overlay-modal ref="overlayModal" width="30%">
    <template v-slot:header>
      <h4 class="cursive">Modifica ricerca</h4>
    </template>
    <template>
      <div class="modal-change-search container">
        <div>
          <form>
            <div class="alert alert-danger">
              <p class="mb-0">
                <b>Attenzione!</b>&nbsp;Modificando i parametri di ricerca
                l'itinerario sarà cancellato
              </p>
            </div>
            <div class="row mb-4">
              <div class="col-12">
                <div class="form-group">
                  <label for="aereoportoId">Aereoporto di partenza</label>
                  <v-select
                    class="form-control"
                    id="aereoportoId"
                    v-model="search.aereoporto"
                    placeholder="Aereoporto di partenza"
                    :options="list"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label for="andataId">Andata il</label>
                  <custom-date-picker
                    id="andataId"
                    v-model="search.andata"
                    :disabled-dates="disabledDatesAndata"
                    @input="onChangeAndata"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label for="ritornoId">Ritorno il</label>
                  <custom-date-picker
                    id="ritornoId"
                    v-model="search.ritorno"
                    :disabled-dates="disabledDatesRitorno"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label for="passeggeriId">Passeggeri</label>
                  <camere-selector
                    ref="camereSelectorRef"
                    id="passeggeriId"
                    v-model="search.camere"
                  />
                </div>
              </div>
            </div>
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary orange"
                @click="onClick"
              >
                Conferma modifiche
              </button>
            </div>
          </form>
        </div>
      </div>
    </template>
  </overlay-modal>
</template>

<script>
import { mapGetters } from "vuex";
import OverlayModal from "../../../../modals/OverlayModal";
import CustomDatePicker from "../../../common/CustomDatePicker";
import CamereSelector from "../../../common/CamereSelector";
import VoloHotelSearcher from "../../../../searcher/VoloHotelSearcher";
import { FAKE_ACTIVE } from "../../../../../utils/config";

export default {
  name: "ModalChangeSearch",
  components: { CamereSelector, CustomDatePicker, OverlayModal },
  mixins: [VoloHotelSearcher],
  data: function () {
    return {
      search: this.getSearch(),
    };
  },
  computed: {
    list: function () {
      return this.getTypesAereoporti().map(function (item) {
        return { label: item.name, value: item.id };
      });
    },
    disabledDatesAndata: function () {
      const toDate = new Date();
      return {
        to: toDate,
      };
    },
    disabledDatesRitorno: function () {
      const fromDate = this.$moment(this.search.andata).add(1, "days").toDate();
      return {
        to: fromDate,
      };
    },
  },
  methods: {
    ...mapGetters(["getSearch", "getTypesAereoporti"]),
    open: function () {
      this.search = this.getSearch();
      this.$refs.overlayModal.open();
    },
    close: function () {
      this.$refs.overlayModal.close();
    },
    onChangeAndata: function () {
      if (this.search.andata.getTime() > this.search.ritorno.getTime()) {
        this.search.ritorno = this.$moment(this.search.andata)
          .add(4, "days")
          .toDate();
      }
    },
    onClick: function () {
      this.close();
      FAKE_ACTIVE ? this.searchFake() : this.searchReal(this.search);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/volo-hotel/modals/ModalChangeSearch.vue